export type IdentityName = 'apple' | 'google' | 'discord';

/** An OIDC id token for POST /v1/auth/link/:provider (IdTokenLink). */
export interface IdentityToken {
  provider: IdentityName;
  idToken: string;
  /**
   * The raw server nonce (GET /v1/auth/nonce) the token was requested with, sent next to it.
   * The token's `nonce` claim is this value or its SHA-256 hex (Apple); single use.
   */
  nonce?: string;
  /**
   * Apple only: the authorization code of the same sign-in, which the API exchanges for the refresh
   * token it revokes on unlink and account deletion (App Store Review Guideline 5.1.1(v)).
   */
  authorizationCode?: string;
  /** Apple on the web only: the return URL the authorization used; Apple checks it again on the exchange */
  redirectUri?: string;
}

export interface IdentityProvider {
  readonly provider: IdentityName;
  signIn(): Promise<IdentityToken>;
}

/** The player closed the sign-in UI; show nothing, keep the guest account. */
export class SignInCancelled extends Error {
  override name = 'SignInCancelled';
  constructor(provider: IdentityName) {
    super(`${provider} sign-in cancelled`);
  }
}
